<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" hide-footer :onClose="onClose">
    <div v-if="contractId && contractData">
      <div v-if="tabselected === 'content1'">
        <div class="row">
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Nº Contrato</div>
            <div class="link-primary" v-if="$store.state.roles.Backoffice_member_empresas"
                 @click="selectTab('content2')">
              {{
                contractData.contractId ||
                contractData.businessContractId ||
                "-"
              }}
            </div>
            <div v-if="!$store.state.roles.Backoffice_member_empresas">
              {{
                contractData.contractId ||
                contractData.businessContractId ||
                "-"
              }}
            </div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Producto</div>
            <div>{{ contractData.product.name || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">IMEI</div>
            <template v-if="contractData.product.imei">
              <div>{{ contractData.product.imei || "-" }}</div>
            </template>
            <template v-if="!contractData.product.imei && $store.state.roles.Backoffice_supervisor">
              <input id="imei" type="text" class="form-control generalInput" v-model.trim.lazy="v$.imei.$model">
            </template>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">ID Logística</div>
            <div>{{ contractData.logisticOrderId || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Creado por</div>
            <div>{{ contractData.createdBy || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Fecha de Inicio</div>
            <div v-if="!$store.state.roles.Backoffice_member_empresas">
              {{ $dateBackToFront(contractData.date, true) }}
            </div>
            <div v-else>
              {{ $dateBackToFront(contractData.transDate, true) }}
            </div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Fecha de Finalización</div>
            <div>{{
                contractData.realEndDate ? $dateBackToFront(contractData.realEndDate, true) : contractData.endDate ? $dateBackToFront(contractData.endDate, true) : "-"
              }}
            </div>
          </div>

          <!-- NUEVOS CAMPOS -->
          <!-- Fecha Fin contratación -->
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Fecha Fin contratación</div>
            <div>{{ $dateBackToFront(contractData.confirmationDate, true) || "-" }}</div>
          </div>

          <!-- Fecha de Facturación -->
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Fecha de Facturación</div>
            <div>{{ $dateBackToFront(contractData.firstPaymentDate, true) || "-" }}</div>
          </div>

          <!-- Fecha real finalización -->
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Fecha real finalización</div>
            <div>{{ $dateBackToFront(contractData.realEndDate, true) || "-" }}</div>
          </div>
          <!-- FIN NUEVOS CAMPOS -->



          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Cuota mensual</div>
            <div>{{ contractData.payment.totalFee || "-" }}€</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Cuota total</div>
            <div>{{ contractData.product.retailPrice || "-" }}€</div>
          </div>

          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Distribuidor</div>
            <div>{{ contractData.merchant || "-" }}</div>
          </div>

          <!-- CAMBIO DE ESTADO -->
          <div class="col-3 mb-3 mt-1">

            <div v-if="isBackofficeAdmin">
              <div class="generalTitleItemModal">Actualizar Estado</div>
              <select v-model="selectedStatus" class="form-control">
                <option v-for="status in filteredStatusOptions" :key="status.value" :value="status.value">
                  {{ status.text }}
                </option>
              </select>

              <button class="btn btn-primary mt-2" @click="updateContractStatus" :disabled="loadingStatus">
      <span v-if="loadingStatus">
        <span v-if="loadingStatus" class="spinner"></span>
      </span>
                <span v-else>
        Actualizar Estado
      </span>
              </button>
            </div>
            <div>
              <div class="generalTitleItemModal">Estado Actual</div>
              {{ contractData.statusDescription || "-" }}
            </div>
            <div v-if="successSave" class="alert alert-success mt-2">{{ successSaveMessage }}</div>
            <div v-if="errorSave" class="alert alert-danger mt-2">{{ errorSaveMessage }}</div>
          </div>


          <!-- FIN CAMBIO DE ESTADO -->

          <div class="col-3 mb-3 mt-1" v-if="contractData.policy && !$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Póliza</div>
            <div>{{ contractData.policy.policyType || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Número de póliza</div>
            <div>{{ contractData.policy.policyNumber || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Tracking</div>
            <template v-if="contractData.tracking">
              <div>{{ contractData.tracking || "-" }}</div>
            </template>
            <template v-if="!contractData.tracking && $store.state.roles.Backoffice_supervisor">
              <input id="tracking" type="text" class="form-control generalInput" v-model.trim.lazy="v$.tracking.$model">
            </template>
          </div>

          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Línea Producto</div>
            <div>{{ translationProductLine(contractData.product.typeProduct) }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Scoring cliente</div>
            <div>{{ contractData.probability || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Póliza</div>
            <div>{{ contractData.policyType || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Orden de distribuidor</div>
            <div>{{ contractData.merchantOrderId || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Url consulta</div>
            <div>
              <a href="https://s.correosexpress.com/" target="_blank"
              >https://s.correosexpress.com/</a
              >
            </div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">PH ID</div>
            <div>{{ contractData.phoneHouseOrderId || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Tienda</div>
            <div>{{ contractData.storeNumber || "-" }}</div>
          </div>
          <div class="col-3 mb-3 mt-1" v-if="$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Cuota total</div>
            <div>{{ this.totalQuote || "-" }} €</div>
          </div>

          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Url Solicitud</div>
            <div>
              <!-- Mensaje cuando no hay URL -->
              <div v-if="!contractData.urlTracking || contractData.urlTracking === ''" class="text-muted">
                URL no disponible
              </div>
              
              <!-- Botones cuando hay URL -->
              <div v-else>
                <div class="d-flex gap-1 mb-2" style="gap: 5px !important;">
                  <button 
                    class="btn btn-sm btn-outline-primary" 
                    @click="openUrl(contractData.urlTracking)"
                    title="Abrir enlace"
                  >
                    <v-icon name="bi-box-arrow-up-right" scale="0.8" class="me-1"/>
                    Abrir enlace
                  </button>
                  <button 
                    class="btn btn-sm btn-outline-secondary" 
                    @click="copyUrl(contractData.urlTracking)"
                    title="Copiar enlace"
                  >
                    <v-icon name="bi-clipboard" scale="0.8" class="me-1"/>
                    Copiar enlace
                  </button>
                </div>
                <!-- Notificación de enlace copiado -->
                <div v-if="urlCopiedNotification" class="alert alert-success py-1 px-2 mb-0" style="font-size: 0.8rem;">
                  {{ urlCopiedNotification }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Rerefence ID de Tink</div>
            <div>
              <div>{{ contractData.externalReference || "-" }}</div>
            </div>
          </div>

          <div class="col-3 mb-3 mt-1" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="generalTitleItemModal">Razón de Aceptación</div>
            <div>
              <div>{{ contractData.reasonAccepted || "-" }}</div>
            </div>
          </div>

          <div class="col-3 mb-3 mt-1" v-if="$store.state.roles.Backoffice_Superadmin">
            <div class="generalTitleItemModal">ID Hocelot</div>
            <div>
              <div>{{ contractData.idHocelot || "-" }}</div>
            </div>
          </div>


        </div>
        <div class="mt-5" v-if="promotions">
          <div>
            DETALLE DE PROMOCIÓN
          </div>
          <template v-for="(promo) in promotions" :key="promo.id">
            <hr>
            <div class="row">
              <div class="col-3 mb-3 mt-1">
                <div class="generalTitleItemModal">Nombre promoción</div>
                {{ promo.name }}
              </div>
              <div class="col-3 mb-3 mt-1">
                <div class="generalTitleItemModal">Tipo promoción</div>
                <template v-if="Array.isArray(promo.feeDiscounts) && promo.feeDiscounts.length > 0">
                  {{ promo.feeDiscounts[0].discountType == "PERCENTAGE" ? 'Porcentaje' : "Absoluto" }}
                </template>
                <template else>-</template>
              </div>
              <div class="col-3 mb-3 mt-1">
                <div class="generalTitleItemModal">Estado</div>
                {{ getTitleStatus(promo.status) }}
              </div>
            </div>
            <div class="row mt-3" v-if="Array.isArray(promo.feeDiscounts) && promo.feeDiscounts.length > 0">
              <div class="col-6 col-lg-1 mb-3 mt-1" v-for="(quote, i) in promo.feeDiscounts" :key="i">
                <div class="generalTitleItemModal">Cuota {{ quote.feeNumber || (i + 1) }}</div>
                <div>{{ quote.value }}{{ quote.discountType == "PERCENTAGE" ? '%' : "€" }}</div>
              </div>
            </div>
          </template>
        </div>
        <div class="mt-5" v-if="$store.state.roles.Backoffice_member_empresas">
          <div id="PrintedDiv">
            <div class="d-flex align-items-center justify-content-between">
              LISTA DE TERMINALES
              <v-icon class="link-primary" name="md-localprintshop-outlined" scale="1.2" title="Imprimir"
                      @click="imprimirDiv"/>
            </div>
            <hr/>
            <div class="overflow-auto">
              <table class="table">
                <thead>
                <tr>
                  <th class="col-10 align-middle">Producto</th>
                  <th class="col-2 align-middle">Unidades</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(product, index) in contractData.orderedProducts"
                    v-bind:key="index"
                >
                  <td class="align-middle py-4">{{ product.name }}</td>
                  <td class="align-middle py-4">{{ product.quantity }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="mt-5 mb-5">
          <div class="container">
            <div>HISTÓRICO DE IMEIs</div>
            <div class="d-flex mr-1" v-if="contractData.status === 'CONFIRMED'">
              <a v-if="showInputImei" href="#" class="mr-4 pb-2 d-flex" @click="toggleImeiInput()">
                <v-icon name="la-minus-circle-solid" class="pr-2" scale="1.2"/>
                Añadir nuevo IMEI
              </a>
              <a v-if="!showInputImei" href="#" class="pb-2 d-flex" @click="toggleImeiInput()">
                <v-icon name="bi-plus-circle" class="pr-2" scale="1.2"/>
                Añadir nuevo IMEI
              </a>
              <div v-if="showInputImei">
                <div class="addInputCointainer d-flex mb-1">
                  <input style="max-width: 20ch;" type="text" class="form-control mr-3" id="newImei"
                         v-model.trim="newImei">
                  <button type="button" class="btn btn-primary" @click="openModal('modalConfirmNewImei')"
                          data-target="#modalConfirmNewImei" data-dismiss="modal"
                          aria-label="Close" data-toggle="modal" :disabled="newImei == ''"
                  >
                    <span>Añadir IMEI</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Botón para cargar histórico de IMEIs bajo demanda -->
          <div v-if="!IMEIsHistoryLoaded" class="row">
            <div class="col-12 mb-3 mt-1 d-flex justify-content-start">
              <button
                class="btn btn-outline-primary"
                @click="loadIMEIsHistory()"
                :disabled="loadingIMEIsHistory"
              >
                <span v-if="loadingIMEIsHistory">
                  <img src="../../../../../assets/loader.svg" height="20" alt="" class="mr-2"/>
                  Cargando...
                </span>
                <span v-else>
                  <v-icon name="bi-arrow-clockwise" class="mr-2" scale="1"/>
                  CARGAR HISTÓRICO
                </span>
              </button>
            </div>
          </div>
          <!-- Tabla de histórico de IMEIs (solo se muestra después de cargar) -->
          <div v-if="IMEIsHistoryLoaded" class="row">
            <div class="col-12 mb-3 mt-1">
              <table class="table">
                <thead>
                <tr>
                  <th class="col-4 align-middle">IMEI</th>
                  <th class="col-4 align-middle">Fecha inicio</th>
                  <th class="col-4 align-middle">Fecha fin</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(imei, index) in IMEIsHistory"
                    v-bind:key="index"
                >
                  <td class="align-middle py-4">{{ imei.imei }}</td>
                  <td class="align-middle py-4">{{ $dateBackToFront(imei.dateFrom, true) }}</td>
                  <td class="align-middle py-4">{{ $dateBackToFront(imei.dateTo, true) }}</td>
                </tr>
                <tr v-if="!IMEIsHistory || IMEIsHistory.length === 0">
                  <td colspan="3" class="text-center text-muted py-4">No hay histórico de IMEIs disponible</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="mt-5 mb-5">
          <div>
            HISTÓRICO DE CONTRATOS
          </div>
          <!-- Botón para cargar histórico de contratos bajo demanda -->
          <div v-if="!contractHistoryLoaded" class="row">
            <div class="col-12 mb-3 mt-1 d-flex justify-content-start">
              <button
                class="btn btn-outline-primary"
                @click="getContratHistory()"
                :disabled="loadingContractHistory"
              >
                <span v-if="loadingContractHistory">
                  <img src="../../../../../assets/loader.svg" height="20" alt="" class="mr-2"/>
                  Cargando...
                </span>
                <span v-else>
                  <v-icon name="bi-arrow-clockwise" class="mr-2" scale="1"/>
                  CARGAR HISTÓRICO
                </span>
              </button>
            </div>
          </div>
          <!-- Tabla de histórico de contratos (solo se muestra después de cargar) -->
          <div v-if="contractHistoryLoaded" class="row">
            <div class="col-12 mb-3 mt-1">
              <table class="table" v-if="contractHistory && Array.isArray(contractHistory) && contractHistory.length > 0">
                <thead>
                <tr>
                  <th class="col-4 align-middle">Fecha cambio</th>
                  <th class="col-4 align-middle">Usuario Ejecuta</th>
                  <th class="col-4 align-middle">Estado Anterior</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(history, index) in contractHistory"
                    v-bind:key="index"
                >
                  <td class="align-middle py-4">{{ $dateBackToFront(history.transChangeDate, true) }}</td>
                  <td class="align-middle py-4">{{ history.userUpdatedId }}</td>
                  <td class="align-middle py-4">{{ history.statusDescription }}</td>
                </tr>
                </tbody>
              </table>
              <div v-else class="text-center text-muted py-4">
                No hay histórico de contratos disponible
              </div>
            </div>
          </div>
        </div>
        <div
            v-if="(contractStatus === 'PENDING_REVIEW_BO' ||
                contractStatus === 'PENDING_REVIEW_EMAIL_DUPLICATED' ||
                contractStatus === 'PENDING_REVIEW_PHONE_DUPLICATED' ||
                contractStatus === 'PENDING_REVIEW_ADDRESS_DUPLICATED') &&
              $store.state.roles.Backoffice_member
              "
            class="row mt-3"
        >
          <div class="col-12">
            <div class="h-100 d-flex justify-content-between">
              <div>
                <button
                    class="btn generalSecondaryButton"
                    data-dismiss="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#denyContractDetail"
                    @click="
                      selectContractPending(
                        contractData.contractId,
                        contractData.status
                      )
                      "
                >
                  Denegar
                </button>
                <button
                    class="btn generalSecondaryButton ml-4"
                    data-dismiss="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#denyBLContractDetail"
                    @click="
                      selectContractPending(
                        contractData.contractId,
                        contractData.status
                      )
                      "
                >
                  Denegar + Black List
                </button>
              </div>
              <div>
                <button
                    class="btn btn-primary generalPrimaryButton"
                    data-dismiss="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#acceptContractDetail"
                    @click="
                      selectContractPending(
                        contractData.contractId,
                        contractData.status
                      )
                      "
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
            v-if="!$store.state.roles.Backoffice_member_empresas"
        >
          <div class="col-12">
            <div class="h-100 d-flex justify-content-end">
              <button
                  v-if="
                    ($store.state.roles.superAdmin || $store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_member) 
                    && (['FINISHED','EARLY_RENEWED','RENOVATED','CANCELED_BY_CUSTOMER','CANCELED_FOR_RETURN','CANCELED_FOR_NON_PAYMENT','CANCELED_FOR_UNPAID_PLUS'].includes(contractStatus))"
                  class="btn generalSecondaryButton"
                  @click="selectTab('content4')"
              >
                COBRO DETERIORO
              </button>
              <div
                v-if="comprobarCancelables(contractStatus) && $store.state.roles.Backoffice_supervisor && !errorSave && !successSave">
                <button class="btn btn-primary generalPrimaryButton" type="button"
                        :disabled="loadingSave"
                        @click="saveData()">
                  <img v-if="loadingSave" src="../../../../../assets/loader.svg" height="20" alt="">
                  <template v-else>
                    Guardar
                  </template>
                </button>
              </div>
              <div v-if="errorSave" style="display: flex; align-items: center; height: 50px">
                <small class="text-danger">{{ errorSaveMessage }}</small>
              </div>
              <div v-if="successSave" style="display: flex; align-items: center; height: 50px">
                <small class="text-success">{{ successSaveMessage }}</small>
              </div>
              <button
                  v-if="comprobarCancelables(contractStatus)"
                  class="btn btn-primary generalPrimaryButton"
                  @click="selectContract(contractData.contractId); selectOtherInfo(contractData.customer.legalIdentifier, contractData.storeNumber, tracking === '' ? contractData.tracking : tracking); endDate=contractData.endDate;"
              >
                Cancelar contrato
              </button>
            </div>
          </div>
        </div>
        <div
            v-if="$store.state.roles.Backoffice_member_empresas"
        >
          <div class="col-12">
            <div class="h-100 d-flex justify-content-end">
              <button
                  class="btn btn-primary generalPrimaryButton"
                  @click="selectContract(contractData.businessContractId); endDate=contractData.endDate;"
              >
                Cancelar contrato
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabselected === 'content2' && $store.state.roles.Backoffice_member_empresas">
      <div id="PrintedDiv">
        <div id="PrintedDiv">
          <div class="d-flex align-items-center justify-content-between">
            LISTA DE TERMINALES DETALLADA
            <v-icon class="link-primary" name="md-localprintshop-outlined" scale="1.2" title="Imprimir"
                    @click="imprimirDiv"/>
          </div>
          <hr/>
          <div class="overflow-auto">
            <table class="table">
              <thead>
              <tr>
                <th class="col-3 align-middle">Producto</th>
                <th class="col-3 align-middle">IMEI</th>
                <th class="col-3 align-middle">R0000000</th>
                <th class="col-3 align-middle">Nº PÓLIZA</th>
                <!-- <th class="col-2 align-middle">Precio</th> -->
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(product, index) in contractData.processedProducts"
                  v-bind:key="index"
              >
                <td class="align-middle py-4">
                  {{ product.customer.line.product.name }}
                </td>
                <td class="align-middle py-4">
                  {{ product.customer.line.product.imei }}
                </td>
                <td class="align-middle py-4">
                  <div class="link-primary" @click="infoContractId(product)">{{ product.contractId }}</div>
                </td>
                <td class="align-middle py-4">
                  {{ product.customer.line.policy.policyNumber }}
                </td>
                <!-- <td class="align-middle py-4">
                {{ product.customer.line.product.retailPrice }}€
              </td> -->
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="!contractData.processedProducts" class="alert alert-info">
          No hay resultados para mostrar
        </div>
        <div
            class="row mt-3"
        >
          <div class="col-12">
            <div class="h-100 d-flex justify-content-start">
              <div>
                <button
                    class="btn generalSecondaryButton"
                    @click="selectTab('content1')"
                >
                  Atrás
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabselected === 'content3'">
      <div class="row">
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Nº Contrato</div>
          <div>
            {{ infoContract.contractId }}
          </div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Producto</div>
          <div>{{ infoContract.name }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">IMEI</div>
          <div>{{ infoContract.imei }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">ID Logística</div>
          <div>{{ infoContract.logisticOrderId }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Fecha de Inicio</div>
          <div> {{ infoContract.date }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Fecha de Finalización</div>
          <div>{{ infoContract.endDate }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Cuota mensual</div>
          <div>{{ infoContract.totalFee }}€</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Cuota total</div>
          <div>{{ infoContract.retailPrice }}€</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Estado</div>
          <div>{{ infoContract.statusDescription }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Tienda</div>
          <div>{{ infoContract.storeNumber }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Número de póliza</div>
          <div>{{ infoContract.policyNumber }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Tracking</div>
          <div>{{ infoContract.tracking }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Distribuidor</div>
          <div>{{ infoContract.merchant }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Scoring cliente</div>
          <div>{{ infoContract.probability }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Orden de distribuidor</div>
          <div>{{ infoContract.merchantOrderId }}</div>
        </div>
        <div class="col-3 mb-3 mt-1">
          <div class="generalTitleItemModal">Url consulta</div>
          <div>
            <a href="https://s.correosexpress.com/" target="_blank"
            >https://s.correosexpress.com/</a
            >
          </div>
        </div>


      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h-100 d-flex justify-content-start">
            <div>
              <button
                  class="btn generalSecondaryButton"
                  @click="selectTab('content2')"
              >
                Atrás
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabselected === 'content4'">
      <div v-if="loadingDeterioro" class="row">
        <div class="col-12 col-lg-12 text-center">
          <img
            src="../../../../../assets/loaderPrimary.svg"
            height="130"
            alt=""
          />
        </div>
      </div>
      <div v-if="!loadingDeterioro" class="row">
        <div class="col-12 col-lg-12 generalTitleItemModal">¿Realmente desea realizar el cobro por deterioro del dispositivo al cliente?</div>
        <div class="col-12 col-lg-12">
          <div class="h-200 d-flex justify-content-between mt-5">
            <div>
              <button
                class="btn btn-primary generalSecondaryButton"
                @click="selectTab('content1')"
              >
                Atrás
              </button>
            </div>
            <div>
              <button
                class="btn btn-primary generalPrimaryButton float-right"
                @click="confirmarDeterioro()"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabselected === 'content5'">
      <div class="row">
        <div class="col-12 col-lg-12 generalTitleItemModal">Se ha iniciado el proceso de cobro.</div>
      </div>
    </div>
    <div v-if="tabselected === 'content6'">
      <div class="row">
        <div class="col-12 col-lg-12"><span class="generalTitleItemModal">Ha ocurrido un error:</span></div>
        <div class="col-12 col-lg-12 mt-4"><span class="text-danger">{{errorMessageDeterioro}}</span></div>
      </div>
    </div>
    <button :id="id + 'CierreModal'" style="display: none;" data-dismiss="modal"/>
  </Modal>
  <ConfirmCancellationBO
      v-if="showModalConfirmCancellationBO"
      @closeModal="onCloseTotalModal"
      :contractData="contractData"
      :numContract="numContract"
      :modalSelected="modalSelected"
      :contractStatus="contractStatus"
      :documentID="documentID"
      :storeNumber="storeNumber"
      :tracking="tracking"
      :endDate="endDate"
      :id="'modalCancellationBO'"
      :modalTitle="'CONFIRMAR CANCELACIÓN DE CONTRATO'"
      :class="'modal-lg'"
      @refreshCancellationBOList="refreshCancellationBOList($event)"
  ></ConfirmCancellationBO>
  <AcceptContractDetail
      :contractId="contractSelected"
      :id="'acceptContractDetail'"
      :modalTitle="'ACEPTAR REVISIÓN'"
      :class="'modal-md'"
  >
  </AcceptContractDetail>
  <DenyContractDetail
      :contractId="contractSelected"
      :id="'denyContractDetail'"
      :modalTitle="'DENEGAR REVISIÓN'"
      :class="'modal-md'"
  >
  </DenyContractDetail>
  <DenyBLContractDetail
      :contractId="contractSelected"
      :id="'denyBLContractDetail'"
      :modalTitle="'DENEGAR REVISIÓN Y AÑADIR A LA BLACK LIST'"
      :class="'modal-md'"
  >
  </DenyBLContractDetail>

  <ModalConfirmNewImei
      :id="'modalConfirmNewImei'"
      :modalTitle="'CONFIRMAR CAMBIO DE IMEI'"
      v-if="showImeiModal"
      @addNewImei="addNewImei($event)"
      @closeModal="onCloseModal"
      :message="modalImeiMessage"
      :imeiConfirmloading="imeiConfirmloading"
      :imeiHasChanged="imeiHasChanged"
  >
  </ModalConfirmNewImei>
</template>

<script>
import axios from "axios";
import Modal from "../../../Shared/Modal.vue";
import ConfirmCancellationBO from "./ConfirmCancellationBO.vue";
import AcceptContractDetail from "./AcceptContractDetail.vue";
import DenyContractDetail from "./DenyContractDetail.vue";
import DenyBLContractDetail from "./DenyBLContractDetail.vue";
import useVuelidate from '@vuelidate/core';
import {Modal as ModalBootstrap} from "bootstrap";
import ModalConfirmNewImei from "./ModalConfirmNewImei.vue";

export default {
  name: "ContractDetail",
  setup() {
    return {v$: useVuelidate()}
  },
  props: [
    "id",
    "modalTitle",
    "class",
    "contractId",
    "contractStatus",
    "contractIndex",
    "cancelables",
  ],
  data() {
    return {
      classes: this.class,
      tabselected: "content1",
      contractData: "",
      numContract: "",
      contractSelected: "",
      statusContract: "",
      totalQuote: "",
      infoContract: {},
      documentID: '',
      storeNumber: '',
      tracking: '',
      endDate: '',
      imei: '',
      newImei: '',
      backOfficeUser: this.$cookies.get('username'),
      loadingSave: false,
      errorSave: false,
      errorSaveMessage: '',
      successSave: false,
      successSaveMessage: 'Se ha enviado la solicitud correctamente',
      promotions: null,
      IMEIsHistory: null,
      IMEIsHistoryLoaded: false,
      loadingIMEIsHistory: false,
      contractHistoryLoaded: false,
      loadingContractHistory: false,
      showModalConfirmCancellationBO: false,
      showImeiModal: false,
      modalImeiMessage: '¿Quieres añadir un nuevo IMEI?',
      imeiConfirmloading: false,
      showInputImei: false,
      imeiHasChanged: false,
      contractHistory: [],
      selectedStatus: this.contractStatus,
      isBackofficeAdmin: false,
      loadingStatus: false,
      allowedStatuses: [
        "TERMINADO Y COMPRA",
        "TERMINADO",
        "RENOVADO",
        "RENOVADO Y COMPRA",
        "RENOVACIÓN ANTICIPADA",
        "IMPAGO",
        "DESISTIDO",
        "CONFIRMADO",
        "CANCELADO POR ACUERDO",
        "CANCELADO POR IMPAGO",
        "CANCELADO POR FRAUDE",
        "CANCELADO POR DEVOLUCIÓN",
        "CANCELADO POR CLIENTE",
        "CANCELACION FRAUDE EN SEGURO",
        "CANCELANDO EL CONTRATO POR IMPAGO+",
        "CANCELADO",
        "IMPAGADO PLUS",
        "CANCELADO ARCHIVADO"
      ],
      statusOptions: [],
      statusObject: [],
      loadingDeterioro: false,
      errorMessageDeterioro: '',
      urlCopiedNotification: '',
    };
  },
  created() {
    this.loadContractData();
    // Históricos se cargan bajo demanda al hacer clic en "CARGAR HISTÓRICO"
    // this.getContratHistory();
    this.checkUserRole();
    this.loadStatusData();
  },
  components: {
    Modal,
    ConfirmCancellationBO,
    AcceptContractDetail,
    DenyContractDetail,
    DenyBLContractDetail,
    ModalConfirmNewImei
  },
  validations() {
    return {
      newImei: {},
      imei: {},
      tracking: {},
    }
  },
  computed: {

    filteredStatusOptions() {
      return this.statusOptions.filter(status =>
          this.allowedStatuses.includes(status.text)
      );
    }
  },
  methods: {
    imprimirDiv() {
      const contenidoDiv = document.getElementById("PrintedDiv").innerHTML;
      const ventanaImpresion = window.open("", "", "width=800,height=600");
      ventanaImpresion.document.write("<html><head><title>Impresión</title>");

      // Estilos personalizados
      ventanaImpresion.document.write(
          "<style>" +
          ".table {" +
          "  width: 100%;" +
          "  margin-bottom: 1rem;" +
          "  color: #212529;" +
          "}" +
          "table {" +
          "  border-collapse: collapse;" +
          "}" +
          "table {" +
          "  display: table;" +
          "  border-collapse: separate;" +
          "  box-sizing: border-box;" +
          "  text-indent: initial;" +
          "  border-spacing: 2px;" +
          "  border-color: gray;" +
          "}" +
          "thead {" +
          "  background-color: rgb(250, 250, 250);" +
          "}" +
          "tr {" +
          "  display: table-row;" +
          "  vertical-align: inherit;" +
          "  border-color: inherit;" +
          "}" +
          ".table thead th {" +
          "  vertical-align: middle;" +
          "  border-bottom: 2px solid #dee2e6;" +
          "}" +
          ".table th, .table td {" +
          "  padding: 0.75rem;" +
          "  vertical-align: top;" +
          "  border-top: 1px solid #dee2e6;" +
          "}" +
          ".link-primary {" +
          "  display: none" +
          "}" +
          "</style>"
      );

      ventanaImpresion.document.write(contenidoDiv);
      ventanaImpresion.document.write("</body></html>");
      ventanaImpresion.document.close();
      ventanaImpresion.print();
    },
    loadContractData() {
      this.promotions = null;
      this.IMEIsHistory = null;
      let urlContratos = "/contract/";
      if (this.$store.state.roles.Backoffice_member_empresas)
        urlContratos = "/business" + urlContratos + "get-contract/";
      axios.get(urlContratos + this.contractId).then((response) => {
        this.contractData = response.data;

        // Asignación de los nuevos campos de fecha
        this.contractData.confirmationDate = response.data.confirmationDate || null;
        this.contractData.firstPaymentDate = response.data.firstPaymentDate || null;
        this.contractData.realEndDate = response.data.realEndDate || null;

        console.log('Datos del contrato:', this.contractData);
        //console.log('Número de cuotas pagadas:', this.contractData.paidInstalments);

        let totalPrice = 0;
        const quotes = this.contractData.orderedProducts

        if (quotes) {
          for (let i = 0; i < quotes.length; i++) {
            console.log(quotes);
            const quote = quotes[i].payment.totalFee;
            const quatity = quotes[i].quantity;
            totalPrice = (totalPrice + (quote * quatity));
          }
          this.totalQuote = totalPrice.toFixed(2);

        } else {
          this.totalQuote = "";
        }

        // Histórico de IMEIs se carga bajo demanda al hacer clic en "CARGAR HISTÓRICO"
        // axios.get(`/contract/${this.contractId}/imeis`).then((response) => {
        //   this.IMEIsHistory = response.data.history;
        // });
      });
      axios.get(`/promotions/promotion-contract/search?pagination.size=1&pagination.pageSize=10&contractId=${this.contractId}`).then((response) => {
        if (response.data.promotionsContract) {
          this.promotions = response.data.promotionsContract;
        }
      });
    },
    translationProductLine(name) {
      let result = "";
      switch (name.toLowerCase(name)) {
        case 'phone':
          result = 'Teléfono';
          break;
        case 'smartwatch':
          result = 'Reloj inteligente';
          break;
        case 'console':
          result = 'Consola';
          break;
        case 'tablet':
          result = 'Tablet';
          break;
        default:
          result = name || "-";
          break;
      }
      return result;
    },
    getContratHistory() {
      this.loadingContractHistory = true;
      axios.get(`contract/history/${this.contractId}`)
          .then((response) => {
            this.contractHistory = response.data.contractHistories;
            this.contractHistoryLoaded = true;
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            this.loadingContractHistory = false;
          });
    },
    loadIMEIsHistory() {
      this.loadingIMEIsHistory = true;
      axios.get(`/contract/${this.contractId}/imeis`)
          .then((response) => {
            this.IMEIsHistory = response.data.history;
            this.IMEIsHistoryLoaded = true;
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            this.loadingIMEIsHistory = false;
          });
    },
    selectContract: function (id) {
      this.numContract = id;
      this.showModalConfirmCancellationBO = true;
      this.$nextTick(() => {
        var myModal = new ModalBootstrap(document.getElementById('modalCancellationBO'))
        myModal.show();
        document.querySelector(`#${this.id}CierreModal`).click();
      })
    },
    selectOtherInfo: function (documentID, storeNumber, tracking) {
      this.documentID = documentID;
      this.storeNumber = storeNumber;
      this.tracking = tracking;
    },
    selectContractPending(id, status) {
      this.contractSelected = id;
      this.statusContract = status;
    },
    selectTab(id) {
      this.tabselected = id;
    },
    infoContractId(product) {
      const dataFinal = {};
      dataFinal.contractId = product.contractId;
      dataFinal.partCode = product.customer.line.product.partCode || "-";
      dataFinal.name = product.customer.line.product.name || "-";
      dataFinal.imei = product.customer.line.product.imei || "-";
      dataFinal.retailPrice = product.customer.line.product.retailPrice || "-";
      dataFinal.policyNumber = product.customer.line.policy.policyNumber || "-";
      dataFinal.logisticOrderId = product.logisticOrderId || "-";
      dataFinal.statusDescription = product.statusDescription || "-";
      dataFinal.storeNumber = product.storeNumber || "-";
      dataFinal.date = this.$dateBackToFront(product.date, true);
      if (product.realEndDate) {
        dataFinal.endDate = this.$dateBackToFront(product.realEndDate, true);
      } else {
        dataFinal.endDate = this.$dateBackToFront(product.endDate, true);
      }
      dataFinal.merchantOrderId = product.merchantOrderId || "-";
      dataFinal.tracking = "-";
      dataFinal.merchant = "-";
      dataFinal.probability = "-";
      dataFinal.totalFee = "-";

      const orderedProduct = this.contractData.orderedProducts.find((item) => item.partCode === dataFinal.partCode);

      if (orderedProduct) {
        dataFinal.totalFee = orderedProduct.payment.totalFee || "-";
      }
      this.infoContract = dataFinal;
      this.tabselected = "content3";
    },
    comprobarCancelables(status) {
      let value = false;
      if (this.$store.state.roles.Backoffice_supervisor) {
        this.cancelables.forEach((element) => {
          if (element == status) value = true;
        });
      } else if (this.$store.state.roles.Backoffice_member) {
        if (status == "UNPAID" || status == "UNPAID") {
          value = true;
        }
      }
      return value;
    },
    refreshCancellationBOList(cancellation) {
      // Propagar se\u00f1al de recarga sin actualizar estado local
      if (cancellation.needsRefresh) {
        let bodyToSend = {
          contractIndex: this.contractIndex,
          contractId: cancellation.contractId,
          needsRefresh: true,
          success: cancellation.success
        };
        this.$emit("refreshContractList", bodyToSend);
      }
    },
    saveData() {
      this.errorSaveMessage = '';
      this.errorSave = false;
      this.loadingSave = true;
      let bodySave = {
        "backOfficeUser": this.backOfficeUser,
        "contractId": this.contractData.contractId,
        "dni": this.contractData.customer.legalIdentifier,
        "imei": this.contractData.product.imei || this.imei,
        "partCode": this.contractData.product.partCode,
        "tracking": this.contractData.tracking || this.tracking,
      }
      axios.post('/logistics-tracking', bodySave)
          .then((response) => {
            this.loadingSave = false;
            if (response.data.message === 'The logistics tracking info row has been inserted.') {
              this.contractData.tracking = this.contractData.tracking || this.tracking;
              this.contractData.product.imei = this.contractData.product.imei || this.imei;
              this.successSave = true;
            }
            if (response.data.message === 'IMEI and Tracking were already set for the input provided. Skipping..') {
              this.tracking = this.contractData.tracking;
              this.imei = this.contractData.product.imei;
              this.errorSave = true;
              this.errorSaveMessage = 'Ya existe un registro pedido para el IMEI y Tracking en curso';
            }
          })
          .catch(() => {
            this.errorSave = true;
            this.errorSaveMessage = 'Ha ocurrido un error, inténtelo de nuevo mas tarde';
            this.loadingSave = false;
            this.tracking = this.contractData.tracking;
            this.imei = this.contractData.product.imei;
            setTimeout(() => {
              this.errorSave = false;
              this.errorSaveMessage = '';
            }, 10000)
          });
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
    },
    onCloseTotalModal() {
      this.showModalConfirmCancellationBO = false;
      this.onClose();
    },
    getTitleStatus(status) {
      switch (status) {
        case 'ACCEPTED':
          return 'ACEPTADA';
        case 'CANCELED':
          return 'CANCELADA';
        case 'PENDING':
          return 'PENDIENTE';
        default:
          return status;
      }
    },

    loadStatusData() {
      let url = `/contract/status-list`;
      if (this.$store.state.roles.Backoffice_member_empresas) {
        url = `/business/contract/status`;
      }
      axios.get(url).then((response) => {
        let arrayStatus = [];
        this.statusObject = response.data;
        this.statusObject.forEach((element) => {
          arrayStatus.push({
            value: element.name,
            text: element.statusDescription
          });
        });
        this.statusOptions = arrayStatus;
      });
    },

    async addNewImei() {
      this.imeiConfirmloading = true
      await axios.patch(`/contract/${this.contractId}/imei/${this.newImei}`).then((response) => {
        this.imeiConfirmloading = false
        this.modalImeiMessage = 'Se ha realizado la acción correctamente.';
        this.imeiHasChanged = true
        console.log(response)
      })
          .catch(() => {
            this.imeiConfirmloading = false;
            this.modalImeiMessage = 'Ha ocurrido un error al realizar la acción. Vuelve a intentarlo más tarde';
            this.imeiHasChanged = true
          });
      await this.loadContractData()
      this.newImei = ''
      this.imeiConfirmloading = false
    },

    openModal() {
      this.showImeiModal = true;
      this.$nextTick(() => {
        var myModal = new ModalBootstrap(document.getElementById('showImeiModal'))
        myModal.show();
      })
    },
    onCloseModal() {
      this.showImeiModal = false;
      this.onClose();
    },
    toggleImeiInput() {
      this.showInputImei = !this.showInputImei;
    },
    checkUserRole() {
      this.isBackofficeAdmin = this.$store.state.roles.Backoffice_admin;
    },
    async updateContractStatus() {
      if (!this.isBackofficeAdmin) {
        this.errorSaveMessage = 'No tienes permiso para actualizar el estado';
        this.errorSave = true;
        setTimeout(() => {
          this.errorSave = false;
        }, 5000);
        return;
      }

      if (!this.selectedStatus) {
        this.errorSaveMessage = 'Seleccione un estado válido';
        this.errorSave = true;
        setTimeout(() => {
          this.errorSave = false;
        }, 5000);
        return;
      }

      if (!this.contractData) {
        this.errorSaveMessage = 'Los datos del contrato no están disponibles';
        this.errorSave = true;
        setTimeout(() => {
          this.errorSave = false;
        }, 5000);
        return;
      }

      const statusTranslationMap = {
        "FINISHED_AND_PURCHASE": "TERMINADO Y COMPRA",
        "FINISHED": "TERMINADO",
        "RENOVATED": "RENOVADO"
      };

      const restrictedStatuses = ["FINISHED_AND_PURCHASE", "FINISHED", "RENOVATED"];
      console.log('Selected status:', this.selectedStatus);
      console.log('Paid instalments:', this.contractData.paidInstalments);

      if (restrictedStatuses.includes(this.selectedStatus) && this.contractData.paidInstalments < 24) {
        this.errorSaveMessage = 'No se puede cambiar el contrato a ' + statusTranslationMap[this.selectedStatus] + ' si no tiene al menos 24 cuotas pagadas';
        this.errorSave = true;
        console.log(this.errorSaveMessage);
        setTimeout(() => {
          this.errorSave = false;
        }, 5000);
        return;
      }

      this.loadingStatus = true;

      try {
        const response = await axios.patch(`/contract/update-status-authorization/${this.contractId}`, {
          status: this.selectedStatus
        });

        if (response.data.code === "CONTRACT-UPDATE-200") {
          this.successSaveMessage = 'Estado actualizado correctamente';
          this.successSave = true;
          const updatedStatus = this.statusOptions.find(option => option.value === this.selectedStatus).text;
          this.$emit('statusUpdated', {
            contractId: this.contractId,
            status: this.selectedStatus,
            statusDescription: updatedStatus
          });
          this.loadContractData();
        } else if (response.data.code === "403") {
          this.errorSaveMessage = "El usuario no tiene autorización para cambiar el estado";
          this.errorSave = true;
        } else {
          this.errorSaveMessage = 'Error al actualizar el estado';
          this.errorSave = true;
        }
      } catch (error) {
        this.errorSaveMessage = 'Ha ocurrido un error al actualizar el estado';
        this.errorSave = true;
      } finally {
        this.loadingStatus = false;
        setTimeout(() => {
          this.errorSave = false;
          this.successSave = false;
        }, 5000);
      }
    },
    confirmarDeterioro() {
      this.loadingDeterioro = true;
      axios.post(`/payment/${this.contractId}/commission/damaged-device`).then(() => {
        this.loadingDeterioro = false;
        this.selectTab('content5');
      })
      .catch((error) => {
        this.loadingDeterioro = false;
        this.errorMessageDeterioro = error.response.data.message || error.response.data.error;
        this.selectTab("content6")
      });
    },

    openUrl(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },

    async copyUrl(url) {
      if (url) {
        try {
          await navigator.clipboard.writeText(url);
          // Mostrar notificación específica para URL copiada
          this.urlCopiedNotification = 'Enlace copiado al portapapeles';
          setTimeout(() => {
            this.urlCopiedNotification = '';
          }, 3000);
        } catch (err) {
          console.error('Error al copiar URL:', err);
          // Fallback para navegadores que no soportan clipboard API
          const textArea = document.createElement('textarea');
          textArea.value = url;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          
          // Mostrar notificación específica para URL copiada
          this.urlCopiedNotification = 'Enlace copiado al portapapeles';
          setTimeout(() => {
            this.urlCopiedNotification = '';
          }, 3000);
        }
      }
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../../../../scss/variables.scss';

.link-primary {
  color: $primary;
  cursor: pointer;

  &:hover {
    color: $primary-hover;
  }
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px;

  .addInputCointainer {
    align-items: center;
  }

}
.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-left-color: #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
